<template>
  <div style="width: 100%">
    <b-card>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <span style="cursor: pointer" @click="selectStep('')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.applied')"
            class="pull-up"
            variant="light-warning"
            size="45"
          >
            <feather-icon size="21" icon="ArrowRightIcon" />
          </b-avatar>
        </span>
        <div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('confirm_valvira')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.valviraConfirmed')"
            class="pull-up"
            variant="light-warning"
            size="45"
          >
            <feather-icon size="21" icon="UserCheckIcon" />
          </b-avatar>
        </span>
        <div style="width: 3%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('no_answer')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.noAnswer')"
            class="pull-up"
            variant="light-secondary"
            size="30"
          >
            <feather-icon size="18" icon="PhoneOffIcon" />
          </b-avatar>
        </span>
        <div style="width: 3%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('schedule')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.interviewScheduled')"
            class="pull-up"
            variant="light-secondary"
            size="30"
          >
            <feather-icon size="18" icon="CalendarIcon" />
          </b-avatar>
        </span>
        <div style="width: 3%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('send_interview')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.interviewSent')"
            class="pull-up"
            variant="light-info"
            size="45"
          >
            <feather-icon size="21" icon="SendIcon" />
          </b-avatar>
        </span>
        <div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('submit_interview')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.interviewSubmitted')"
            class="pull-up"
            variant="light-warning"
            size="45"
          >
            <feather-icon size="21" icon="MessageSquareIcon" />
          </b-avatar>
        </span>
        <div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('confirm_interview')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.interviewConfirmed')"
            class="pull-up"
            variant="light-warning"
            size="45"
          >
            <feather-icon size="21" icon="CheckSquareIcon" />
          </b-avatar>
        </span>
        <div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('request_documents')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.requestDocuments')"
            class="pull-up"
            variant="light-info"
            size="45"
            :badge="badgeApplicationRequest > 0 ? badgeApplicationRequest.toString() : null"
            :badge-top="true"
            badge-offset="-5px"
          >
            <feather-icon size="21" icon="FileTextIcon" />
          </b-avatar>
        </span>
        <div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span style="cursor: pointer" @click="selectStep('confirmed_documents')">
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.confirmedDocuments')"
            class="pull-up"
            variant="light-warning"
            size="45"
          >
            <feather-icon size="21" icon="UserMinusIcon" />
          </b-avatar>
        </span>
        <!--<div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span
          style="cursor: pointer"
          @click="selectStep('waiting_for_contract')"
        >
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.waitingForOffer')"
            class="pull-up"
            variant="light-warning"
            size="45"
          >
            <feather-icon
              size="21"
              icon="ThumbsUpIcon"
            />
          </b-avatar>
        </span>
        <div style="width: 6%; border-bottom: 1px solid #ebe9f1;" />
        <span
          style="cursor: pointer"
          @click="selectStep('contract_pending')"
        >
          <b-avatar
            v-b-tooltip.hover
            :title="$t('application.steps.interviewConfirmed')"
            class="pull-up"
            variant="light-info"
            size="45"
          >
            <feather-icon
              size="21"
              icon="ShareIcon"
            />
          </b-avatar>
        </span>-->
      </div>
    </b-card>
  </div>
</template>
<script>
import { BCard, BAvatar, VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BAvatar,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    stepFilter: {
      type: [String, null],
      default: '',
    },
    badgeApplicationRequest: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    selectStep(step) {
      this.$emit('update:stepFilter', step)
    },
  },
}
</script>
<style lang="scss" scoped></style>
